import styled from 'styled-components';
import { Content } from '../CommonComponents/OPL/StickyFooter/StickyFooter';
import { WORKFLOW_PADDING, WORKFLOW_WIDTH } from './Workflow.meta';
import { Box } from '../CommonComponents/OPL/Box/Box';

export const WorkflowWrapper = styled(Content)({
  width: WORKFLOW_WIDTH,
  marginLeft: 'auto',
  marginRight: 'auto',
  padding: `0px ${WORKFLOW_PADDING}px`,
});

export const DefaultWrapper = styled(Box)({
  maxWidth: 1200,
  minWidth: 1000,
  margin: '0 auto',
  padding: 40,
  minHeight: 'calc(100vh - 100px)',
});
